import React from 'react'
import ProfileIcon from '../../assets/images/ProfileIcon.png'
import GreenTick from '../../assets/images/GreenTick.png'
import { useLocation, useNavigate } from 'react-router-dom';

function ActivePayments() {

    const navigate = useNavigate();
    const location = useLocation();
    const user = location.state?.user;

    const handleClick = () => {
        navigate('/users');
    };

    return (
        <div className='users main-Page-css' style={{ minHeight: '94vh' }}>
            <button className='backbox mb-2' onClick={handleClick}>
                Back
            </button>
            <div className='main-page-title'>User list</div>
            <div className='mainbox'>
                <div className='d-flex'>
                    <img src={ProfileIcon} style={{ width: '120px', objectFit: 'contain' }} />
                    <div style={{ marginLeft: 24, width: '100%' }}>
                        <p className='profile-title'>{user.fullName || 'N/A'}</p>
                        <div className='row'>
                            <div className='col-6'>
                                <div className='mainbox3'>
                                    <div className='d-flex align-items-center justify-content-between '>
                                        <div className='d-flex' >
                                            <p className='boxheading'>Gender</p>
                                        </div>
                                        <div>
                                            <p className='boxheading text1 me-2' style={{ color: '#7265E3', textTransform: 'capitalize' }}>{user.gender || 'N/A'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='mainbox3'>
                                    <div className='d-flex align-items-center justify-content-between '>
                                        <div className='d-flex' >
                                            <p className='boxheading'>Birth Date</p>
                                        </div>
                                        <div>
                                            <p className='boxheading text1 me-2' style={{ color: '#7265E3', textTransform: 'capitalize' }}>N/A</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='row'>
                            <div className='col-6'>
                                <div className='mainbox3'>
                                    <div className='d-flex align-items-center justify-content-between '>
                                        <div className='d-flex' >
                                            <p className='boxheading'>Email</p>
                                        </div>
                                        <p className='boxheading text1 me-2' style={{ color: '#7265E3' }}>{user.email || 'N/A'}</p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='mainbox3'>
                                    <div className='d-flex align-items-center justify-content-between '>
                                        <div className='d-flex' >
                                            <p className='boxheading'>Premium Subscription</p>
                                        </div>
                                        <div className='d-flex'>
                                            <p className='boxheading text1 me-2' style={{ textTransform: 'capitalize' }}>{user.premiumsubscription || 'N/A'}</p>
                                            {/* <img src={GreenTick} className='staricon' /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ActivePayments